import { useCallback, useState } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { useDownloader } from '@trinity/chat-components/hooks/useDownloader';

export interface UseExportMessageTestingPptResult {
  exporting: boolean;
  exportPpt: () => Promise<void>;
}

export function useExportMessageTestingPpt(runId: number): UseExportMessageTestingPptResult {
  const apiClient = useChatApiClient();
  const download = useDownloader();
  const [exporting, setExporting] = useState(false);

  const exportPpt = useCallback(async () => {
    setExporting(true);
    try {
      const blob = await apiClient.messageTesting.exportPpt(runId);
      download({ blob, filename: 'message_insights.pptx' });
    } catch {
      // Silently fail — the user can retry
    } finally {
      setExporting(false);
    }
  }, [apiClient, runId, download]);

  return { exporting, exportPpt };
}
